<template>
  <div v-if="page" class="flex flex-wrap -mx-2 mt-6 text-sm">
    <div class="w-full md:w-1/2 px-2">
      <panel class="pt-6">
        <h1 class="text-lg">Terms &amp; Conditions</h1>
        <loader v-if="loading" />
        <div v-else>
          <div v-if="terms.sending" class="pt-6">
            <h2 class="text-base">Referring Agent - Terms &amp; Conditions</h2>
            <p v-html="terms.sending" class="leading-normal page-content"></p>
          </div>
          <div v-if="terms.receiving" class="pt-6">
            <h2 class="text-base">Receiving Agent - Terms &amp; Conditions</h2>
            <p v-html="terms.receiving" class="leading-normal page-content"></p>
          </div>
        </div>
      </panel>
    </div>

    <div class="w-full md:w-1/2 px-2">
      <panel class="pt-6">
        <h1 class="text-lg">Privacy Policy</h1>
        <loader v-if="loading" />
        <p v-else v-html="terms.privacy" class="leading-normal page-content"></p>
      </panel>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    page: Object
  },
  data () {
    return {
      terms: {
        sending: '',
        receiving: '',
        privacy: ''
      },
      loading: true
    }
  },
  computed: {
    ...mapState(['referralTerms'])
  },
  created () {
    this.loadReferralTerms()
  },
  methods: {
    ...mapActions(['fetchReferralTerms']),
    loadReferralTerms () {
      if (!this.referralTerms) {
        this.fetchReferralTerms().then(() => {
          this.terms = this.referralTerms
          this.loading = false
        })
      } else {
        this.terms = this.referralTerms
        this.loading = false
      }
    }
  }
}
</script>
